export function getWebSocketUrl() {
  return `${process.env.NEXT_PUBLIC_WS_URL}/ws`
}
